<div (click)="switchTopBar()" class="hide-bar-icon">
  <mat-icon>{{(barDisplayed$|async) ? 'arrow_circle_up' : 'arrow_circle_down'}}</mat-icon>
</div>
